import request from "@/axios";
import type { UserLoginType, UserInfoType, ChangePasswordParam } from "./types";

interface RoleParams {}

// 登录管理API接口
export const loginApi = (
  data: UserLoginType,
): Promise<IResponse<UserInfoType>> => {
  return request.post({ url: "/login/login", data });
};

export const loginOutApi = (
  data: { language?: string } = {},
): Promise<IResponse> => {
  return request.post({ url: "/login/logout", data });
};

export const getAdminRoleApi = (
  params: RoleParams = {},
): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.post({ url: "/auth/getAuth", data: params });
};

export const getTestRoleApi = (
  params: RoleParams = {},
): Promise<IResponse<string[]>> => {
  return request.post({ url: "/auth/getAuth", data: params });
};

// 修改用户密码
export const changePwdApi = (data: ChangePasswordParam) => {
  return request.post<Result<any>>({ url: "/login/changePassword", data });
};
